import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject, ElementRef } from '@angular/core';
import { DialogComponentContent } from '@toro/common/shared/models/dialogs/DialogComponentContent';
import { OrderSideEnum } from '@toro/common/shared/enum/orders/side.enum';

@Component({
  selector: 'resume-groupment-cards-dialog',
  templateUrl: './resume-groupment-cards-dialog.component.html',
  styleUrls: ['./resume-groupment-cards-dialog.component.scss'],
})
export class ResumeGroupmentCardsDialogComponent extends DialogComponentContent {
  public libMath = Math;

  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData,
    public elementRef: ElementRef,
    private dialogReference: MatDialogRef<ResumeGroupmentCardsDialogComponent>,
  ) {
    super(elementRef);
  }

  public dataToCheckout() {
    return {
      isDaytrade: this.dialogData.isDaytrade,
      total: this.dialogData.total,
      side: this.dialogData.side === OrderSideEnum.Compra ? OrderSideEnum.Venda : OrderSideEnum.Compra
    }
  }

  /**
   * Encerra o componente informando se há confirmação
   * @param confirm confirmação para realizar incrição ou cancelamento.
   */
  public closeDialog() {
    super.close(this.dialogReference, null);
  }
}
